import { render, staticRenderFns } from "./CustomFieldsFilters.vue?vue&type=template&id=38ff920b&scoped=true&"
import script from "./CustomFieldsFilters.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFieldsFilters.vue?vue&type=style&index=0&id=38ff920b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff920b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ff920b')) {
      api.createRecord('38ff920b', component.options)
    } else {
      api.reload('38ff920b', component.options)
    }
    module.hot.accept("./CustomFieldsFilters.vue?vue&type=template&id=38ff920b&scoped=true&", function () {
      api.rerender('38ff920b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_CustomFields/CustomFieldsFilters.vue"
export default component.exports